<div class="m-nexpeSearch">
  <input
    type="text"
    class="m-nexpeSearch__input"
    [value]="searchQuery()"
    (input)="onSearchInput($event)"
    [placeholder]="'NEXPE.SEARCH_PLACEHOLDER' | translate"
  />
</div>
